import _ from "lodash";
import React from "react";
import { IconButton } from "@toddle-edu/ds-web";
import { MentionOutlined } from "@toddle-edu/ds-icons";
function ActionItems({
  renderAddButton,
  renderEmojiComponent,
  isTaggingEnabled,
  renderAudioRecorderComponent,
  renderAIActionItems,
  active,
  chatBarRef,
  enableChatPanel = false,
  chatPanelRef,
  testId,
}) {
  return (
    <>
      {renderAddButton({ showTooltip: false })}
      {renderEmojiComponent()}
      {isTaggingEnabled && (
        <IconButton
          icon={<MentionOutlined />}
          _legacy_variant={"plain"}
          type="plain"
          variant="neutral"
          size={"small"}
          isActivated={active}
          onClick={() => {
            if (enableChatPanel) {
              const handleInsert = _.get(
                chatPanelRef,
                "current.handleInsert",
                _.noop
              );
              handleInsert("@");
            } else chatBarRef.current.handleInsert("@");
          }}
          testId={testId ? `${testId}-mention` : undefined}
          aria-label="Mention User"
        />
      )}
      {renderAudioRecorderComponent()}
      {_.isFunction(renderAIActionItems) ? renderAIActionItems() : null}
    </>
  );
}

export default React.memo(ActionItems);
